import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";

// Components
import Search from "./Search";

// Context
import { VideosContext } from "../../context/videos";

const SearchContainer = (props) => {
    /**
     * Router Hooks
     */

    const history = useHistory();

    /**
     * useContext
     */

    const { fetchVideoSearchResults } = useContext(VideosContext);

    /**
     * useState
     */

    const [search, setSearch] = useState("");

    /**
     * End Hooks
     */

    function onChange(e) {
        const { value } = e.target;
        setSearch(value);
    }

    function onSubmit(e) {
        e.preventDefault();
        fetchVideoSearchResults(search);
        history.push("/videos");
    }

    return (
        <Search
            {...props}
            onChange={onChange}
            onSubmit={onSubmit}
            search={search}
        />
    );
};

export default SearchContainer;
